import { compareId } from '../../helpers';
import { getForm1WasteProducts } from '../../helpers/cadastrHelper';
import { precisionAdd } from '../../helpers/numberHelper';
import { WASTE_CONDITION_ENUM } from '../enums';
import { responsiblePersonsFormsPercentGetter } from './responsiblePersonsFormsPercentGetter';

export const getInitialComponentCompositions = () => ({
  randId: Math.random(),
  component_name: '',
  mass_fraction: 0,
});

export const getInitialForm2Item = () => ({
  waste_approval_date: '',
  is_developed_passport: true,
  is_passport_approved: false,
  is_known_component_composition: false,
  name_technological_process: '',
  component_compositions: [getInitialComponentCompositions()],
  [WASTE_CONDITION_ENUM]: '',
});

export const HAZARD_CLASSES = ['one', 'two', 'three', 'four'];

export const filterComponentComposition = (data) => (!data ? [] : data
  .filter(({ code }) => HAZARD_CLASSES.includes(code?.hazard_class)));

export const form2PercentGetterItem = (data, addAllDataLength, { newErrors, waste }) => {
  let totalFilledCount = 0;
  let hasError = false;

  const addTotalCount = (count) => {
    totalFilledCount += count;
  };

  if (data.is_developed_passport && data.is_passport_approved) {
    addAllDataLength(3);

    if (data[WASTE_CONDITION_ENUM]?.id || compareId(data[WASTE_CONDITION_ENUM]?.name, 0)) addTotalCount(1);
    else hasError = true;

    if (data.waste_approval_date || compareId(data.waste_approval_date, 0)) addTotalCount(1);
    else hasError = true;

    if (data.name_technological_process) addTotalCount(1);
    else hasError = true;
  }

  if (data.is_known_component_composition) {
    data.component_compositions.forEach(({ component_name, mass_fraction }) => {
      addAllDataLength(2);

      if (component_name) addTotalCount(1);
      else hasError = true;

      if (mass_fraction) addTotalCount(1);
      else hasError = true;
    });

    const sumMassFraction = data.component_compositions
      ?.reduce?.((prevCount, componentItem) => precisionAdd(prevCount, componentItem?.mass_fraction), 0) || 0;

    if (sumMassFraction !== 0 && sumMassFraction < 100) {
      addAllDataLength(1);
      hasError = true;
    }
  }

  if (hasError && window?.showCadastreErrors) {
    newErrors.push(`waste${waste.randId}`);
  }

  return totalFilledCount;
};

export const form2PercentGetter = (forms, { errorSetter }) => {
  const { items: buildings } = forms.form1;

  const wasteProducts = getForm1WasteProducts(buildings);
  const isHasOnlyFiveHazardClasses = wasteProducts?.length && wasteProducts.every(({ code }) => code?.hazard_class === 'five');

  const filteredWastes = filterComponentComposition(wasteProducts);
  let allDataLength = 0;
  let totalFilledCount = 0;
  const getPercents = () => {
    return Math.floor((totalFilledCount / allDataLength) * 100);
  };

  const addAllDataLength = (count) => {
    allDataLength += count;
  };

  const addFilledCount = () => {
    totalFilledCount += 1;
  };

  if (forms.form2) {
    responsiblePersonsFormsPercentGetter(forms.form2, addAllDataLength, addFilledCount);
  }
  if (isHasOnlyFiveHazardClasses) return !allDataLength ? 100 : getPercents();
  if (filteredWastes.length === 0) return 0;

  if (filteredWastes.every((item) => !item.form2Waste.is_developed_passport)) return !allDataLength ? 100 : getPercents();
  if (
    filteredWastes.every((item) => !item.form2Waste.is_passport_approved) &&
    forms.form2?.responsiblePersons?.every(
      (person) => person.fio && person.position && person.phone_num
    )
  )
    return !allDataLength ? 100 : getPercents();
  const newErrors = [];

  totalFilledCount += filteredWastes.reduce((prev, waste) => {
    const { form2Waste } = waste;
    const totalItemPercent = form2PercentGetterItem(form2Waste, addAllDataLength, { newErrors, waste });
    return prev + totalItemPercent;
  }, 0);

  errorSetter({ errorForm2: newErrors });

  return getPercents();
};
